import moment from 'moment'
import { getLocalStorageItem, setLocalStorageItem } from '../../../utils/helpers/localStorage'
import storage from '../../../utils/constants/storage'

export const shouldOpenCampaignNow = campaignId => {
  const lastView = getLocalStorageItem(`${storage.LAST_CAMPAIGN_VIEW_PREFIX}_${campaignId}`)
  return !lastView || moment().diff(moment(lastView), 'hours') >= 24
}

export const setLastCampaignView = campaignId => {
  setLocalStorageItem(`${storage.LAST_CAMPAIGN_VIEW_PREFIX}_${campaignId}`, moment().toISOString())
}
